/**
 * 产品研发数字化（/product-research）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C(scope, key, default) 读取。
 */
import {
  RESEARCH_CENTERS, ENV_METRICS, ENV_TREND, RESEARCH_DEVICES,
  DEVICE_SUMMARY, EXPERIMENT_DIFF, DIFF_REASONS, LIVE_PORTS, RESEARCH_UPDATED_AT,
} from '@/data/productResearch'

export default {
  title: '产品研发数字化',
  groups: [
    {
      title: '页头区域',
      fields: [
        { key: 'headTitle', label: '页面主标题', type: 'text', default: '产品研发数字化 · 双研发中心协同' },
        { key: 'cdChip', label: '成都研发中心标签', type: 'text', default: '成都研发中心 · 海拔 500 m' },
        { key: 'lhChip', label: '炉霍研发中心标签', type: 'text', default: '炉霍研发中心 · 海拔 3 250 m' },
        { key: 'devChipPre', label: '设备统计前缀', type: 'text', default: '设备' },
        { key: 'devChipMid', label: '设备统计中缀', type: 'text', default: '台 · 运行' },
        { key: 'devChipSuf', label: '设备统计后缀', type: 'text', default: '台' },
        { key: 'todayChipPre', label: '今日批次前缀', type: 'text', default: '今日实验批次' },
        { key: 'snapPre', label: '数据快照前缀', type: 'text', default: '数据快照' },
        { key: 'snapSuf', label: '数据快照后缀', type: 'text', default: '· 接口预留 /api/research/*' },
        { key: 'backFromChain', label: '返回按钮（产业链来源）', type: 'text', default: '返回产业链' },
        { key: 'backDefault', label: '返回按钮（默认）', type: 'text', default: '返回' },
        { key: 'mn1Title', label: '视频区标题', type: 'text', default: '两地同步实验实时视频区' },
      ],
    },
    {
      title: '直播窗口',
      fields: [
        { key: 'liveTip', label: '直播区说明文字', type: 'textarea', default: '接入端口预留：支持 RTMP / HLS(m3u8) / FLV 流；大屏端建议由网关转封装为 HLS 或 mp4 直连。两窗口并列即双中心同步操作画面。' },
        { key: 'portLabel', label: '接入端口标签', type: 'text', default: '接入端口' },
        { key: 'portPlaceholder', label: '推流地址占位提示', type: 'text', default: '推流地址，如 https://live.xxx.com/{key}.m3u8' },
        { key: 'connectText', label: '接入按钮', type: 'text', default: '接入' },
        { key: 'disconnectText', label: '断开按钮', type: 'text', default: '断开' },
        { key: 'liveWindowText', label: '未接入占位标题', type: 'text', default: '16 : 9 直播窗口' },
        { key: 'liveWaitingSuf', label: '未接入占位后缀', type: 'text', default: '· 信号待接入' },
      ],
    },
    {
      title: '实验室环境对比',
      fields: [
        { key: 'envTitle', label: '卡片标题', type: 'text', default: '实验室环境实时对比' },
        { key: 'envSub', label: '卡片副标题', type: 'text', default: '适宜区间外判定「偏离」' },
        { key: 'envHeadMetric', label: '表头·环境指标', type: 'text', default: '环境指标' },
        { key: 'envHeadCd', label: '表头·成都研发中心', type: 'text', default: '成都研发中心' },
        { key: 'envHeadLh', label: '表头·炉霍研发中心', type: 'text', default: '炉霍研发中心' },
        { key: 'envHeadDiff', label: '表头·两地差值', type: 'text', default: '两地差值' },
        { key: 'envHeadJudge', label: '表头·判定', type: 'text', default: '判定' },
        { key: 'envPillOk', label: '判定·正常', type: 'text', default: '正常' },
        { key: 'envPillWarn', label: '判定·偏离', type: 'text', default: '偏离' },
      ],
    },
    {
      title: '24h 环境趋势',
      fields: [
        { key: 'trendTitle', label: '卡片标题', type: 'text', default: '24h 环境趋势' },
        { key: 'trendSub', label: '卡片副标题', type: 'text', default: '成都 vs 炉霍' },
        { key: 'trendTempTitle', label: '温度图标题', type: 'text', default: '温度（℃）' },
        { key: 'trendHumTitle', label: '湿度图标题', type: 'text', default: '相对湿度（%）' },
      ],
    },
    {
      title: '研发设备概览',
      fields: [
        { key: 'ovTitle', label: '卡片标题', type: 'text', default: '研发设备概览' },
        { key: 'ovLabelTotal', label: '统计·设备总数', type: 'text', default: '设备总数' },
        { key: 'ovLabelRunning', label: '统计·运行中', type: 'text', default: '运行中' },
        { key: 'ovLabelMonth', label: '统计·本月实验', type: 'text', default: '本月实验' },
        { key: 'ovLabelToday', label: '统计·今日批次', type: 'text', default: '今日批次' },
        { key: 'ovPowerOn', label: '进度·开机率', type: 'text', default: '开机率' },
        { key: 'ovOee', label: '进度·设备综合利用率 OEE', type: 'text', default: '设备综合利用率 OEE' },
        { key: 'ovDist', label: '进度·设备分布', type: 'text', default: '设备分布' },
        { key: 'ovStatusTitle', label: '进度·运行状态', type: 'text', default: '运行状态' },
      ],
    },
    {
      title: '研发设备运行清单',
      fields: [
        { key: 'tableTitle', label: '卡片标题', type: 'text', default: '研发设备运行清单' },
        { key: 'tableSub', label: '卡片副标题', type: 'text', default: '近 24h · 重点设备' },
        { key: 'thName', label: '表头·设备名称', type: 'text', default: '设备名称' },
        { key: 'thModel', label: '表头·型号', type: 'text', default: '型号' },
        { key: 'thCenter', label: '表头·所属中心', type: 'text', default: '所属中心' },
        { key: 'thCategory', label: '表头·工艺环节', type: 'text', default: '工艺环节' },
        { key: 'thStatus', label: '表头·状态', type: 'text', default: '状态' },
        { key: 'thRuntime', label: '表头·运行(h)', type: 'text', default: '运行(h)' },
        { key: 'thLoad', label: '表头·负载', type: 'text', default: '负载' },
        { key: 'thBatches', label: '表头·批次', type: 'text', default: '批次' },
        { key: 'thMaint', label: '表头·下次保养', type: 'text', default: '下次保养' },
      ],
    },
    {
      title: '双中心实验结果差异',
      fields: [
        { key: 'diffTitle', label: '卡片标题', type: 'text', default: '双中心实验结果差异' },
        { key: 'diffSub', label: '卡片副标题', type: 'text', default: '同一方法两地并行' },
        { key: 'dhItem', label: '表头·检测指标', type: 'text', default: '检测指标' },
        { key: 'dhCd', label: '表头·成都', type: 'text', default: '成都' },
        { key: 'dhLh', label: '表头·炉霍', type: 'text', default: '炉霍' },
        { key: 'dhGap', label: '表头·差异', type: 'text', default: '差异' },
        { key: 'dhBetter', label: '表头·优势方', type: 'text', default: '优势方' },
        { key: 'betterCd', label: '优势方·成都', type: 'text', default: '成都更优' },
        { key: 'betterLh', label: '优势方·炉霍', type: 'text', default: '炉霍更优' },
      ],
    },
    {
      title: '归因说明（底条）',
      fields: [
        { key: 'reasonTag', label: '底条标签', type: 'text', default: '环境差异 → 结果差异' },
      ],
    },
    {
      title: '媒体展示（三维场景）',
      fields: [
        { key: 'vsMedia', label: '实验室三维可视化场景图片', type: 'text', default: '', hint: '填素材库图片地址（/media/image/...）或完整 URL；留空显示待接入占位' },
      ],
    },
    {
      title: '数据指标（直接编辑当前值）',
      fields: [
        { key: 'summary', label: '设备总览数据', type: 'object', default: DEVICE_SUMMARY },
        { key: 'devices', label: '设备运行清单数据', type: 'array', default: RESEARCH_DEVICES },
        { key: 'envMetrics', label: '实验室环境指标', type: 'array', default: ENV_METRICS },
        { key: 'experimentDiff', label: '实验结果差异数据', type: 'array', default: EXPERIMENT_DIFF },
        { key: 'diffReasons', label: '归因说明列表', type: 'array', default: DIFF_REASONS },
        { key: 'centers', label: '研发中心信息', type: 'array', default: RESEARCH_CENTERS },
        { key: 'livePorts', label: '直播窗口端口配置', type: 'array', default: LIVE_PORTS },
        { key: 'updatedAt', label: '数据快照时间', type: 'text', default: RESEARCH_UPDATED_AT },
      ],
    },
    // 「图片与视频」组已移除：页面背景图固定跟随「甘孜市场」底图（ganzi/pageBg → 通用市场底图 → bg_shichang.jpg），
    // 原产品研发独立 pageBg 配置不再生效，避免后台配置了却不起作用的陷阱
  ],
}
